module.exports = __webpack_public_path__ + "static/developer-london-home-desk-24d14130a6d7d140fd12bf6c778dfb3c.svg";